module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DwKCO4/images/frontcover.jpg?1703000871560",
      "alt": "This image is the cover for the book Foul Deeds & Suspicious Deaths in London's West End, Foul Deeds & Suspicious Deaths"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Foul Deeds & Suspicious Deaths in London's West End, Foul Deeds & Suspicious Deaths\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("London's West End is associated with fashion and glamour but for centuries it has had a far darker side. Geoffrey Howse has uncovered an astonishing catalogue of sinister deeds, some of them famous but others long forgotten. Read about spying, treason, embezzlement, regicide, robbery, forgery, religious persecution, suicide, murder and mutilation; and 'witness' horrendous punishments such as drawing, hanging, disemboweling, quartering, castration, beheading and burning. Earlier cases include the execution of Scottish patriots (1305/6) and three monks who dared to question the supremacy of Henry VIII in 1535. Such events attracted great public attention, as did the extraordinary execution of Charles I in 1649 and, in 1820, the hanging and mutilation of the Cato Street Conspiritors. The foul murder of the famous actor William Terriss, by a madman, in 1897, is featured as are several notable cases from the twentieth century including the horrific wartime murders of Gordon Cummins, the strange disappearances of the socialist MP Victor Grayson and Lord Lucan, the Charing Cross Trunk Murder as well as the mysterious death of boxer Freddie Mills.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Geoffrey Howse\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wharncliffe\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0